import { useParams, Redirect } from 'react-router-dom';
import React, { useMemo, useEffect } from 'react';
import { getVideoById } from '../../selectors/getVideoById';

export const OnDemandScreen = ({ history }) => {

    const { videoId } = useParams();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    
    const video = useMemo(() => getVideoById( videoId ), [ videoId ]);
    if ( !videoId ) {
        return <Redirect to="/" />;
    }

    const handleReturn = () => {
            history.goBack();
    }

    const {
        profesor,
        position,
        situation,
        link,
        title,
        description,
        likes
    } = video;

  return (
    <>
        <div className="container mt-3 animate__animated animate__fadeIn">
            <p align="center">
                <iframe
                    width="1000"
                    height="575"
                    auto
                    src="https://www.youtube.com/embed/z2OXnXu3_nc?controls=0&autoplay=1"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{display:"block"}}
                ></iframe>
            </p>

            <div>
                <h3 align="center"> { title } </h3>
                <ul className="list-group list-group-flush">
                    <li className="list-group-item"> <b> Instructor/es: </b> { profesor } </li>
                    <li className="list-group-item"> <b> Posición: </b> { position } </li>
                    <li className="list-group-item"> <b> Situación: </b> { situation } </li>
                    <li className="list-group-item"> <b> Likes: </b> { likes } </li>
                </ul>
                <br></br>

                <p> { description } </p>

            </div>
        </div>
    </>
  )
}
